import { InvoiceTotalPriceColumns } from '../enums/invoiceTotalPriceColumns'

export const isInvoiceTotalPriceColumns = (value: string): value is InvoiceTotalPriceColumns => {
  return Object.values(InvoiceTotalPriceColumns).includes(value as InvoiceTotalPriceColumns)
}
